module.exports = __webpack_public_path__ + "img/36_68.61d6b2f0.png";